import * as React from 'react'
import { Button, Form, Header, Icon, Transition, Input } from 'semantic-ui-react'
import './InfoPage.css'
import { homeService, userService } from '../../../../../services'
import { toast } from 'react-toastify'
import { InputField } from '../../../../components'
import { connect } from 'react-redux'

type IData = {
  steamId?: string,
  oldPassword?: string,
  newPassword?: string,
  confirmPassword?: string,
  offerLink?: string,
}

type InfoPageState = {
  showChangePass: boolean,
  showChangeSteam: boolean,
  showChangeOfferLink: boolean,
  isLoading: boolean,
  data: IData,
}

type InfoPageProps = {
  loggedIn: boolean
  userInfo: IUserInfo,
}

class InfoPage extends React.Component<InfoPageProps, InfoPageState> {
  state: InfoPageState = {
    showChangePass: false,
    showChangeSteam: false,
    showChangeOfferLink: false,
    isLoading: false,
    data: {
      steamId: this.props.userInfo.steamId,
      offerLink: this.props.userInfo.offerLink,
    },
  }

  toggleShowChangeSteam = () => {
    const { showChangeSteam } = this.state
    if (!showChangeSteam) { this.setState({ showChangePass: false, showChangeOfferLink: false }) }
    this.setState({
      showChangeSteam: !showChangeSteam,
    })

  }

  toggleShowChangePass = () => {
    const { showChangePass } = this.state
    if (!showChangePass) { this.setState({ showChangeSteam: false, showChangeOfferLink: false }) }
    this.setState({
      showChangePass: !showChangePass
    })
  }

  toggleShowChangeOfferLink = () => {
    const { showChangeOfferLink } = this.state
    if (!showChangeOfferLink) {
      this.setState({
        showChangeSteam: false,
        showChangePass: false
      })
    }
    this.setState({
      showChangeOfferLink: !showChangeOfferLink
    })
  }

  handleChangeData = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target
    let data = this.state.data
    data[name] = value
    this.setState({ data: data })
  }

  handleSaveSteamId = () => {
    const steamId = this.state.data.steamId
    if (!steamId) {
      toast.error('Không được để trống SteamId')
      return
    }
    this.setState({
      isLoading: true,
    })
    userService.updateSteam(steamId)
      .then(result => {
        toast.success('Thay đổi steamId thành công!')
        this.setState({
          isLoading: false,
          showChangeSteam: !this.state.showChangeSteam
        })
      }).catch(error => {
        toast.error('Thay đổi steamId không thành công! Thông tin: ' + error.message)
        this.setState({
          isLoading: false,
        })
      })
  }

  handleSaveOfferLink = () => {
    const offerLink = this.state.data.offerLink
    if (!offerLink) {
      toast.error('Không được để trống steam offer url')
      return
    }
    this.setState({
      isLoading: true,
    })
    userService.updateOfferLink(offerLink)
      .then(result => {
        toast.success('Thay đổi offer url thành công!')
        this.setState({
          isLoading: false,
          data: { offerLink: result },
          showChangeOfferLink: !this.state.showChangeOfferLink
        })
      }).catch(error => {
      toast.error('Thay đổi offer url không thành công! Thông tin: ' + error.message)
      this.setState({
        isLoading: false,
      })
    })
  }

  handleSavePassword = () => {
    const { data } = this.state
    const newPassword = data.newPassword
    const oldPassword = data.oldPassword
    if (!newPassword || !oldPassword) {
      toast.error('Không được để trống mật khẩu!')
      return
    }
    this.setState({
      isLoading: true,
    })
    userService.updatePassword(oldPassword, newPassword)
      .then(result => {
        toast.success('Thay đổi mật khẩu thành công!')
        this.setState({
          isLoading: false,
          showChangePass: !this.state.showChangePass
        })
      })
      .then(() => homeService.getAppState())
      .catch(error => {
        toast.error('Thay đổi mật khẩu không thành công! Thông tin: ' + error.message)
        this.setState({
          isLoading: false,
        })
      })
  }

  handleCancelEdit = () => {
    if (this.state.showChangeSteam) {
      this.setState({
        showChangeSteam: !this.state.showChangeSteam,
    })}

    if (this.state.showChangePass) {
      this.setState({
        showChangePass: !this.state.showChangePass,
      })
    }

    if (this.state.showChangeOfferLink) {
      this.setState({
        showChangeOfferLink: !this.state.showChangeOfferLink,
      })
    }
  }

  render() {
    const { showChangeSteam, showChangePass, data, showChangeOfferLink } = this.state
    return (
        <Form widths={'equal'}>
          <Header as="h1">
            <Icon name="settings" />
            <Header.Content>
              Thiết lập tài khoản
                <Header.Subheader>Quản lí Steam ID và mật khẩu</Header.Subheader>
            </Header.Content>
          </Header>
          <Form.Group inline={true} unstackable={true}>
            <Form.Field>
              <label>Steam ID</label>
              <Input
                name="steamId"
                value={data.steamId}
                disabled={!showChangeSteam}
                onChange={this.handleChangeData}
                fluid={true}
              />
            </Form.Field>
            <Form.Field>
              <Button size="mini" icon="edit" onClick={this.toggleShowChangeSteam} />
            </Form.Field>
          </Form.Group>
          <Transition
            visible={showChangeSteam}
            duration={200}
            animation={'scale'}
            divided={true}
            verticalAlign="middle"
          >
            <Form.Group inline={true} unstackable={true}>
              <Button size="mini" onClick={this.handleSaveSteamId} className="button">Lưu</Button>
              <Button size="mini" onClick={this.handleCancelEdit} className="button">Hủy</Button>
            </Form.Group>
          </Transition>

          <Form.Group inline={true} unstackable={true}>
            <Form.Field>
              <label>Steam offer URL</label>
              <Input
                name="offerLink"
                value={data.offerLink}
                disabled={!showChangeOfferLink}
                onChange={this.handleChangeData}
                type={'text'}
                fluid={true}
              />
            </Form.Field>
            <Form.Field>
              <Button size="mini" icon="edit" onClick={this.toggleShowChangeOfferLink} />
            </Form.Field>
          </Form.Group>
          <Transition
            visible={showChangeOfferLink}
            duration={200}
            animation={'scale'}
            divided={true}
            verticalAlign="middle"
          >
            <Form.Group inline={true} unstackable={true}>
              <Button size="mini" onClick={this.handleSaveOfferLink} className="button">Lưu</Button>
              <Button size="mini" onClick={this.handleCancelEdit} className="button">Hủy</Button>
            </Form.Group>
          </Transition>

          <Form.Group inline={true}>
            <Form.Field>
              <label>Mật khẩu</label>
              <Input
                disabled={true}
                type={'password'}
                name="password"
                value="12312312"
              />
            </Form.Field>
            <Form.Field>
              <Button size="mini" icon="edit" onClick={this.toggleShowChangePass} />
            </Form.Field>
          </Form.Group>
          <Transition visible={showChangePass} duration={200} animation={'scale'} verticalAlign="middle">
            <Form.Group inline={true}>
              <InputField
                type={'password'}
                onChange={this.handleChangeData}
                name="oldPassword"
                placeholder="Mật khẩu hiện tại"
                value={data.oldPassword}
              />
              <InputField
                type={'password'}
                onChange={this.handleChangeData}
                name="newPassword"
                placeholder="Mật khẩu mới"
                value={data.newPassword}
              />
              <InputField
                type={'password'}
                onChange={this.handleChangeData}
                name="confirmPassword"
                placeholder="Xác nhận mật khẩu"
                value={data.confirmPassword}
              />
              <Button size="mini" onClick={this.handleSavePassword} >Lưu</Button>
              <Button size="mini" onClick={this.handleCancelEdit} >Hủy</Button>
            </Form.Group>
          </Transition>
          <Form.Group inline={true}>
            <Button animated={true} color="red">
              <Button.Content visible={true}>Lưu</Button.Content>
              <Button.Content hidden={true}>
                <Icon name="save" />
              </Button.Content>
            </Button>
          </Form.Group>
        </Form>
    )
  }
}

const mapStateToProps = (state: IAppState, ownProps: any) => ({
  ...ownProps,
  loggedIn: state.loggedIn,
  userInfo: state.root.userInfo,
})

export default connect(mapStateToProps)(InfoPage)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/modules/HomeRoll/modules/User/containers/InfoPage.tsx